import "./profile.css";

import React, { Component, Fragment } from "react";

import Auth from "../../services/authService";
import Footer from "../../components/page/footer";
import Header from "../../components/page/header";
import { Link } from "react-router-dom";
import Page from "../../components/page/page";
import ProfileNav from "./profileNav";
import Purchases from "./purchases";

const user = Auth.getCurrentUser();

export default class userProfile extends Component {
  render() {
    if (!Auth.getCurrentUser()) return (window.location = "/login");

    return (
      <Page>
        <Header />
        <ProfileNav />
        <section className="container">
          <div className="row hrow headbox-dark">
            <h3 className="title">تمام دستگاه های من</h3>
          </div>
          <Purchases />
          <div className="row hrow mt-4">
            <Link className="btn btn-dark" to="/ServiceRequest">
              {" "}
              درخواست خدمات
            </Link>
          </div>
        </section>
        <Footer />
      </Page>
    );
  }
}
